enum WriteDirectionEnum {
	ltr = 'ltr',
	rtl = 'rtl'
}

export default WriteDirectionEnum;
